export default {"src":"/_next/static/media/vertical-separator.817e9a19.svg","height":14,"width":2,"blurWidth":0,"blurHeight":0};